import { render } from "./Accord.vue?vue&type=template&id=646b8fd8"
import script from "./Accord.vue?vue&type=script&lang=js"
export * from "./Accord.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__